import { render, staticRenderFns } from "./ChargebackAnalyticsVerifiTable.vue?vue&type=template&id=7295ea0f&"
import script from "./ChargebackAnalyticsVerifiTable.vue?vue&type=script&lang=js&"
export * from "./ChargebackAnalyticsVerifiTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
